module.exports = __webpack_public_path__ + "img/loading.fe97296a.png";